import GetAwaySearchRepository from "~/core/ts/repository/get-away/GetAwaySearchRepository"
import { useSelectorToQueryParam } from "../shared/useSelectorToQueryParam"

export function useGetAwayAvailabilitySearchStorage() {
  const {
    optionSelected: selectedDateRange,
    pushQueryParam: pushDateRangeQueryParam,
    runOnMounted: runOnMountedDateRange,
    onValueChanged: onDateRangeChanged
  } = useSelectorToQueryParam({
    label: 'date-range',
    defaultValue: ''
  }, false)

  const {
    optionSelected: selectedPax,
    pushQueryParam: pushPaxQueryParam,
    runOnMounted: runOnMountedPax,
    onValueChanged: onPaxChanged,
  } = useSelectorToQueryParam({
      label: 'pax',
      defaultValue: '0',
    }, false)

  const selectedPaxValue = computed(() => {
    if (!selectedPax.value.value) {
      return '0'
    }

    return selectedPax.value.value
  })

  const selectedDateRangeValue = computed(() => {
    if (!selectedDateRange.value.value) {
      return ''
    }

    return selectedDateRange.value.value
  })

  const isActive = ref(false)

  onDateRangeChanged(() => {
    if (!isActive.value) {
      return
    }
    GetAwaySearchRepository.storeDateQuery(selectedDateRangeValue.value)
  })

  onPaxChanged(() => {
    if (!isActive.value) {
      return
    }
    GetAwaySearchRepository.storePaxQuery(selectedPaxValue.value)
  })

  onMounted(() => {
    setTimeout(async () => {
      runOnMountedDateRange()
      runOnMountedPax()

      if (!selectedDateRangeValue.value) {
        const dateQuery = GetAwaySearchRepository.getDateQuery()
        await pushDateRangeQueryParam(dateQuery)
      } else {
        GetAwaySearchRepository.storeDateQuery(selectedDateRangeValue.value)
      }

      if (selectedPaxValue.value === '0' || selectedPaxValue.value === '2') {
        const paxQuery = GetAwaySearchRepository.getPaxQuery()

        if (paxQuery && paxQuery !== selectedPaxValue.value) {
          await pushPaxQueryParam(paxQuery)
        }
      } else {
        GetAwaySearchRepository.storePaxQuery(selectedPaxValue.value)
      }

      isActive.value = true
    }, 100)
  })
}
